export default {"src":"/_next/static/media/star.d7313989.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};